import * as React from 'react';
import { useDoOnce } from '@cian/valuation-utils-component';
/** Оборачивает пользовательский коллбэк в useDoOnce обертку, если требуется */

export var useGetCallback = function useGetCallback(cb, triggerOnce) {
  var onceCb = useDoOnce(cb);
  return React.useMemo(function () {
    return triggerOnce ? onceCb : cb;
  }, [cb, onceCb, triggerOnce]);
};